import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { KeyRound, MailCheck } from "lucide-react";

// One flow for every account type (owner / manager / customer).
export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Could not send the reset email — try again in a bit");
    }
    setBusy(false);
  };

  return (
    <div className="min-h-screen qd-admin grid place-items-center p-6">
      <div className="w-full max-w-sm bg-white rounded-2xl p-8 border border-gray-200 shadow-sm">
        <div className="w-10 h-10 rounded-lg bg-[var(--qd-charcoal)] grid place-items-center mb-6">
          {sent ? <MailCheck className="w-4 h-4 text-white" aria-hidden /> : <KeyRound className="w-4 h-4 text-white" aria-hidden />}
        </div>
        {sent ? (
          <>
            <h1 className="font-display text-2xl font-bold tracking-tight">Check your email</h1>
            <p className="text-sm text-gray-500 mt-2" data-testid="forgot-sent">
              If an account exists for <b>{email}</b>, a reset link is on its way. It works for 30 minutes.
            </p>
          </>
        ) : (
          <>
            <h1 className="font-display text-2xl font-bold tracking-tight">Forgot password</h1>
            <p className="text-sm text-gray-500 mb-6">Enter your account email — works for owners, managers and customers.</p>
            <form onSubmit={submit} className="space-y-3">
              <Input data-testid="forgot-email" required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="h-11 rounded-lg" />
              <Button data-testid="forgot-submit" type="submit" disabled={busy} className="w-full h-11 rounded-lg bg-[var(--qd-charcoal)] hover:bg-black text-white font-semibold">
                {busy ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          </>
        )}
        <Link to="/admin/login" className="block mt-4 text-sm text-gray-500 hover:text-gray-800 text-center">← Back to sign in</Link>
      </div>
    </div>
  );
}
